import { render, staticRenderFns } from "./EditCreateProduct.vue?vue&type=template&id=7f0f064b"
import script from "./EditCreateProduct.vue?vue&type=script&lang=js"
export * from "./EditCreateProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports